<script lang="ts">
  import { _ } from 'svelte-i18n'
  import {isDirtySearch, isShowSearchLoader, list, pagination} from '../../../../../stores';
</script>

{#if $isDirtySearch && $list.length && !$isShowSearchLoader && !$pagination.next_page_number }
  <hr>
  <div class="title">{$_('searchCompleteText')}</div>
{/if}

<style lang="scss">
  hr {
    margin-top: 36px;
    margin-bottom: 16px;
  }

  .title {
    font-size: 16px;
    line-height: 23px;
    text-align: center;
    color: #22252C66;
  }
</style>